import { segmentTrackEvent } from '../../ducks/analytics_tracking/thunks';
import { useAppDispatch } from '../../store/react_redux_typed';
import Button from '../../ui/button/button';
import type { ButtonVariant } from '../../ui/button/types';
import { VARIANTS } from '../../ui/label/label';
import TooltipTrigger from '../tooltip_trigger/tooltip_trigger';

const formatPath = (path?: string) => (path || '').replace('?embeddable', '');

type Props = {
  path: string;
  title: string;
  className?: string;
  variant?: ButtonVariant;
};

const HelpButton = (props: Props) => {
  const dispatch = useAppDispatch();
  const { className, title, variant, path } = props;

  const onNavigate = (): void => {
    dispatch(
      segmentTrackEvent({
        eventName: 'See Help',
        properties: {
          Path: path,
        },
      }),
    );

    const newWindow = window.open(formatPath(path));
    if (newWindow) {
      newWindow.opener = null;
    }
  };

  return (
    <div className={className} onClick={onNavigate}>
      <TooltipTrigger tooltipText={`See ${title} Help`}>
        <Button
          iconName="help_tooltip"
          variant={variant || VARIANTS.INFO}
          noBorder
          wideBasis={false}
        />
      </TooltipTrigger>
    </div>
  );
};

export default HelpButton;
